import Api from './Api.js'
import ApiMap from './ApiMap.js'
import Req from './Req.js'
import RunType from './RunType.js'
import * as Base from './Base.js'

const { axios, axiosG, axiosP, ToastPool } = Base


export {
  Api,                // Api 接口，使用时指定如 Api.order/wwwRoot
  ApiMap,             // Api 接口映射
  RunType,            // 0/1/2/3 注意是字符串
  axios,
  axiosG,
  axiosP,
  ToastPool,          // 吐司池，一般用在请求上
  Req,                // 用处不大 统一发起请求，用处不大
}
